import { $ui, loadingHandler, promiseConfirm, toast, tryCatchConfirm } from '@/utils/ui'
import { postCircuits } from '@/utils/api/agency/circuits'
import store from '@/store'
import {
  USER_AGENCY_POST_AGENT,
  USER_AGENCY_POST_CHECKPOINT,
  USER_AGENCY_POST_CLIENT,
  USER_AGENCY_POST_RONDE,
  USER_AGENCY_POST_SITE
} from '@/store/modules/user/agency/action-types'
import { dateFormatIso } from '@/utils/data/date'
import { postAgencyEstimate } from '@/utils/api/agency/estimates'
import {
  COMMERCIAL_DOC_TYPE_CUSTOMER_EMAIL_KEY,
  COMMERCIAL_DOC_TYPE_CUSTOMER_SLUG_KEY,
  COMMERCIAL_DOC_TYPE_ESTIMATE,
  COMMERCIAL_DOC_TYPE_ESTIMATE_CUSTOMER_EMAIL_KEY,
  COMMERCIAL_DOC_TYPE_ESTIMATE_CUSTOMER_KEY,
  COMMERCIAL_DOC_TYPE_INVOICE,
  COMMERCIAL_DOC_TYPE_INVOICE_CUSTOMER_KEY,
  COMMERCIAL_DOC_TYPE_INVOICE_INVOICE,
  COMMERCIAL_DOCS_STATUS_DELETED
} from '@/consts/commercialDocs'
import { postAgencyInvoice } from '@/utils/api/agency/invoices'
import { devLog, plz } from '@/utils'
import {
  MODAL_EVENT_UPDATE_AGENT_CONTRACT_TEMPLATE,
  MODAL_EVENT_UPDATE_AGENT_REQUEST,
  MODAL_EVENT_UPDATE_CHANGELOG,
  MODAL_EVENT_UPDATE_CUSTOMER_CONTRACT_TEMPLATE,
  MODAL_EVENT_UPDATE_ESTIMATES,
  MODAL_EVENT_UPDATE_FEEDBACK,
  MODAL_EVENT_UPDATE_INTERVENTION_REPORTS,
  MODAL_EVENT_UPDATE_INVOICE_RECURRENCE,
  MODAL_EVENT_UPDATE_INVOICES,
  MODAL_EVENT_UPDATE_MANAGER,
  MODAL_EVENT_UPDATE_UNAVAILABILITIES
} from '@/consts/app'
import { CUSTOMERS_TYPE_COMPANY } from '@/consts/customers'
import { postAgencyManager } from '@/utils/api/agency/manager'
import { postAgencyAgentUnavailability } from '@/utils/api/agency/agent/unavailability'
import { postAgencyInterventionReport } from '@/utils/api/agency/interventionReports'
import { USER_PUT_USER } from '@/store/modules/user/action-types'
import {
  basculerService,
  checkServices,
  checkServicesConflictingUnavailability,
  checkServicesFormError,
  parseService
} from '@/utils/services'
import { postAgencyEmail } from '@/utils/api/agency/emails'
import {
  ACCOUNT_MANAGER_DEFAULT_RIGHTS,
  ACCOUNT_RIGHT_CREATE_AGENT,
  ACCOUNT_RIGHT_CREATE_CHECKPOINT,
  ACCOUNT_RIGHT_CREATE_CUSTOMER,
  ACCOUNT_RIGHT_CREATE_ESTIMATE,
  ACCOUNT_RIGHT_CREATE_INTERVENTION_REPORT,
  ACCOUNT_RIGHT_CREATE_INVOICE,
  ACCOUNT_RIGHT_CREATE_MISSION,
  ACCOUNT_RIGHT_CREATE_MISSION_EVENT,
  ACCOUNT_RIGHT_CREATE_REQUEST,
  ACCOUNT_RIGHT_CREATE_ROUND,
  ACCOUNT_RIGHT_CREATE_SELF_REQUEST,
  ACCOUNT_RIGHT_CREATE_SITE,
  ACCOUNT_RIGHT_CREATE_UNAVAILABILITY,
  ACCOUNT_RIGHT_EDIT_AGENT,
  ACCOUNT_RIGHT_EDIT_CHECKPOINT,
  ACCOUNT_RIGHT_EDIT_CUSTOMER,
  ACCOUNT_RIGHT_EDIT_ESTIMATE,
  ACCOUNT_RIGHT_EDIT_INTERVENTION_REPORT,
  ACCOUNT_RIGHT_EDIT_INVOICE,
  ACCOUNT_RIGHT_EDIT_MISSION,
  ACCOUNT_RIGHT_EDIT_MISSION_EVENT,
  ACCOUNT_RIGHT_EDIT_REQUEST,
  ACCOUNT_RIGHT_EDIT_ROUND,
  ACCOUNT_RIGHT_EDIT_SITE,
  ACCOUNT_RIGHT_EDIT_SITE_ITEMS,
  ACCOUNT_RIGHT_EDIT_UNAVAILABILITY,
  ACCOUNT_RIGHT_LIST_MISSION_EVENTS,
  ACCOUNT_RIGHT_LIST_SITE_ITEMS,
  ACCOUNT_RIGHT_LIST_SITE_MISSION_EVENTS,
  ACCOUNT_RIGHT_READ_AGENT,
  ACCOUNT_RIGHT_READ_CUSTOMER,
  ACCOUNT_RIGHT_READ_SITE,
  ACCOUNT_RIGHT_READ_SITE_MISSION_EVENTS,
  ACCOUNT_RIGHT_SEND_ESTIMATE,
  ACCOUNT_RIGHT_SEND_INVOICE
} from '@/consts/rights'
import { getForbiddenMessage } from '@/utils/data/rights'
import { fetchServices } from '@/utils/api/services'
import { SERVICE_ACTIVITY_TYPE_GARDIENNAGE, SERVICES_DUPLICATE_PLANNING_ERRORS } from '@/consts/services'
import { userName } from '@/utils/data/agents'
import { getAgencySiteItems, postAgencySiteItems } from '@/utils/api/agency/customer/sites'
import { INTERVENTION_REPORTS_STATUS_SIGNED_CUSTOMER } from '@/consts/interventionReports'
import { postAgencyAgentRequest } from '@/utils/api/agency/agent/request'
import { ROUTE_NAME_CHOOSE_PLAN } from '@/router/routes'
import { routerPush } from '@/utils/routing'
import { getAgentSubscriptionValue } from '@/utils/data/pricings'
import { postChangelog } from '@/utils/api/applicationVersion'
import { onStatusChange } from '@/utils/data/agentRequests'
import { duplicatePlanning } from '@/utils/api/agency/customer/planning'
import { postFeedback } from '@/utils/api/feedback'
import { postAgencyInvoicesRecurrence } from '@/utils/api/agency/invoicesRecurrence'
import { postAgencyCustomerContractTemplate } from '@/utils/api/agency/contractCustomerTemplates'
import { postAgencyAgentContractTemplate } from '@/utils/api/agency/contractAgentTemplates'
import { chipedTextToText, textToHtml } from '@/utils/data/contract'
import { CONTRACT_TYPES_AGENT, CONTRACT_TYPES_CUSTOMER } from '@/consts/data/contract'

/**
 * Détermine si l'utilisateur est autorisé à accéder à la modale
 * @param subject
 * @param createRight
 * @param editRight
 */
const throwUnlessGranted = (subject, createRight, editRight) => {
  if (
    ((Array.isArray(subject) && subject.some((s) => !s.id)) || !subject.id) &&
    !store.getters['user/isGranted'](createRight)) {
    throw new Error(getForbiddenMessage(createRight))
  }
  if (
    ((Array.isArray(subject) && subject.some((s) => s.id)) || subject.id) &&
    !store.getters['user/isGranted'](editRight)) {
    throw new Error(getForbiddenMessage(editRight))
  }
}

const submitServices = async (_services, modal) => {
  try {
    await checkServices(_services)
    await loadingHandler(async () => {
      // const { services } =
      await postCircuits({ services: _services })
      // $ui.$emit(MODAL_EVENT_UPDATE_SERVICES, services)
      modal.hide()
    })
  } catch (e) { }
}

/**
 * Générateur de modal générique
 * @param {Object} subject
 * @param {String} type
 * @param {String} title
 * @param {String} entityTitle
 * @param {Boolean} feminize
 * @param {String} dialogName
 * @param {function} submit
 * @param {Object} props
 * @param readonly
 * @returns {Promise<*>}
 * @private
 */
const _defaultModal = async ({
  subject,
  readonly = false,
  type,
  title,
  entityTitle,
  feminize = false,
  dialogName,
  submit,
  props = {}
}) => {
  // Le chargement des dialog doit être asynchrone pour éviter le problème des composants récursifs
  const dialog = await import('components/Dialog/' + dialogName)
  return $ui.addModal({
    props: {
      title: title || (type
        ? Array.isArray(subject)
          ? `Ajout / modification des ${type}` + (type[type.length - 1] === 's' ? '' : 's')
          : subject && subject.id
            ? `${readonly ? 'Consultation' : 'Modification'} d'un${feminize ? 'e' : ''} ${type}` + (entityTitle ? ' - ' + entityTitle : '')
            : `Ajout d'un${feminize ? 'e' : ''} ${type}`
        : ''),
      persistent: true
    },
    component: {
      is: dialog.default, // export.default
      props: {
        readonly,
        value: _.cloneDeep(subject),
        type,
        ...props
      },
      on: submit
        ? { submit }
        : {}
    }
  })
}

/**
 * Affiche une modal avec un mail
 * @param mail
 * @param {{ auto: boolean }} opt - L'option auto permet d'utiliser la méthode d'expédition par défaut
 * @returns {Promise<*>}
 */
export const modalEmail = async (mail = { message: '' }, opt = { auto: false }) => {
  const _mail = _.merge(
    {},
    {
      from: store.getters['user/company'].email,
      message: ''
    },
    mail)
  const modal = await _defaultModal({
    subject: _mail,
    type: 'email',
    dialogName: 'DialogEmail'
  })
  if (opt.auto) {
    modal.on('submit', ({
      attachments = [],
      lockedAttachments = [],
      ...email
    }) => loadingHandler(async () => {
      await postAgencyEmail({
        ...email,
        attachments: [
          ...attachments,
          ...lockedAttachments
        ]
      })
      modal.hide()
    }))
  }
  return modal
}

/**
 * Affiche une modal avec une liste de fichiers
 * @param files
 * @param email
 */
export const modalFiles = (files = [], email = {}) => {
  return _defaultModal({
    subject: files.map((f, i) => ({
      ...f,
      id: i
    })),
    type: 'fichiers',
    dialogName: 'DialogFiles',
    props: {
      email: email
    }
  })
}

export const modalPreview = (fileUrl = '') => {
  return _defaultModal({
    subject: _.stubObject(),
    dialogName: 'DialogPreview',
    title: 'Prévisualisation du document',
    props: {
      fileUrl: fileUrl
    }
  })
}

/**
 * Affiche une modal de signature
 * @returns {Promise<*>}
 */
export const modalSignature = async (signature) =>
  _defaultModal({
    subject: signature,
    type: 'signature',
    dialogName: 'DialogSignature'
  })

/**
 * Affiche une modal de signature de contrat
 * @returns {Promise<*>}
 */
export const modalContractSignature = async (
  contractSignature,
  type = 'agent',
  isSender = false,
  readonly = false
) =>
  _defaultModal({
    title: 'Signature d\'un contrat',
    subject: contractSignature.signature ?? '',
    type,
    dialogName: 'DialogContractSignature',
    props: {
      id: contractSignature.contract.id,
      token: contractSignature.signatureToken,
      readonly,
      isSender
    }
  })

/**
 * Créé une modal de création d'un service
 * @param service
 */
export const modalService = async (service = {
  activityType: SERVICE_ACTIVITY_TYPE_GARDIENNAGE,
  agents: [],
  breaks: [],
  rounds: [],
  nbAgents: 1
}) => {
  throwUnlessGranted(service, ACCOUNT_RIGHT_CREATE_MISSION, ACCOUNT_RIGHT_EDIT_MISSION)
  const modal = await _defaultModal({
    subject: parseService(service),
    type: 'service',
    dialogName: 'DialogService',
    submit: (_services) => tryCatchConfirm(async () => {
      await checkServicesFormError(_services)
      return submitServices(_services, modal)
    })
  })
}

/**
 * Créé une modal de création de demande
 * @param agentRequest
 * @param readonly
 */
export const modalAgentRequest = async (
  agentRequest = {
    requestType: '',
    subject: '',
    content: '',
    agent: null
  },
  readonly = false
) => {
  const modal = await _defaultModal({
    title: 'Ajout d\'une demande',
    subject: agentRequest,
    type: 'request',
    dialogName: 'DialogRequest',
    submit: async ({ ...aRequest }) => {
      try {
        throwUnlessGranted(agentRequest, ACCOUNT_RIGHT_CREATE_REQUEST, ACCOUNT_RIGHT_EDIT_REQUEST)
      } catch (e) {
        if (agentRequest.id || !store.getters['user/isGranted'](ACCOUNT_RIGHT_CREATE_SELF_REQUEST)) {
          throw e
        }
      }
      if (!store.getters['user/isGranted'](ACCOUNT_RIGHT_CREATE_REQUEST)) {
        aRequest.agent = store.state.user.utilisateur
      }
      if (aRequest._status) {
        await onStatusChange(agentRequest, aRequest._status)
        modal.hide()
      } else {
        return loadingHandler(async () => {
          const request = await postAgencyAgentRequest(aRequest)
          $ui.$emit(MODAL_EVENT_UPDATE_AGENT_REQUEST, [request])
          modal.hide()
        })
      }
    },
    props: {
      readonly
    }
  })
}

/**
 * Modal d'affichage de la main courante d'un service
 * @param service
 * @returns {Promise<void>}
 */
export const modalServiceMainCourantes = (service) => {
  throwUnlessGranted(service, ACCOUNT_RIGHT_LIST_MISSION_EVENTS, ACCOUNT_RIGHT_LIST_MISSION_EVENTS)
  return loadingHandler(async () => {
    await _defaultModal({
      title: 'Main courante du service ' + (service.reference || ''),
      subject: service,
      type: 'serviceMainCourantes',
      dialogName: 'DialogServiceTimeline'
    })
  })
}
/**
 * Génère une modal de visualisation des mains courantes d'un site à partir d'un service
 * @param service
 * @param readonly
 * @returns {Promise<void>}
 */
export const modalSiteMainCourante = (service, readonly = false) => {
  throwUnlessGranted(service, ACCOUNT_RIGHT_LIST_SITE_MISSION_EVENTS, ACCOUNT_RIGHT_LIST_SITE_MISSION_EVENTS)
  const { site } = service
  return loadingHandler(async () => {
    await _defaultModal({
      title: 'Mains courantes du site ' + ((site && site.name) || ' ??'),
      subject: service,
      type: 'siteMainCourantes',
      dialogName: 'DialogSiteEventTimeline',
      readonly
    })
  })
}

/**
 * Modal de gestion de plusieurs services
 * @param services
 */
export const modalServices = (services = []) => {
  throwUnlessGranted(services, ACCOUNT_RIGHT_CREATE_MISSION, ACCOUNT_RIGHT_EDIT_MISSION)
  return loadingHandler(async () => {
    const { data } = await fetchServices(
      {
        limit: 0,
        filters: {
          services: services.map((s) => s.reference)
        },
        read: true
      })
    const modal = await _defaultModal({
      subject: data.map(parseService),
      type: 'service',
      dialogName: 'DialogServices',
      submit: (_services) => tryCatchConfirm(async () => {
        await checkServicesFormError(_services)
        await promiseConfirm(`Modifier ${_services.length} ${plz('service', _services)} ?`)
        return submitServices(_services, modal)
      })
    })
  })
}

export const modalServiceEnd = async (service) => {
  const modal = await _defaultModal({
    subject: service,
    title: 'Badge de fin de service',
    dialogName: 'DialogServiceEnd',
    submit: async (_service) => {
      try {
        await basculerService(_service)
        modal.hide()
      } catch (e) {}
    }
  })
  return modal
}

/**
 * Affiche une modal de création / modification d'une indispo
 * @param unavailability
 * @returns {Promise<void>}
 */
export const modalUnavailability = async (unavailability = {}) => {
  throwUnlessGranted(unavailability, ACCOUNT_RIGHT_CREATE_UNAVAILABILITY, ACCOUNT_RIGHT_EDIT_UNAVAILABILITY)
  const modal = await _defaultModal({
    subject: {
      ...unavailability
    },
    type: 'indisponibilité',
    dialogName: 'DialogUnavailability',
    submit: async (_agentUnavailability) => {
      await loadingHandler(async () => {
        const { agentUnavailability } = await postAgencyAgentUnavailability(_agentUnavailability)
        $ui.$emit(MODAL_EVENT_UPDATE_UNAVAILABILITIES, [agentUnavailability])
        modal.hide()
      }, { reject: true })
      await tryCatchConfirm(() => checkServicesConflictingUnavailability(_agentUnavailability))
    }
  })
}

/**
 * Affiche une map
 * @param mapInfos
 */
export const modalMap = async (mapInfos) => {
  await _defaultModal({
    subject: mapInfos,
    titre: 'Carte',
    dialogName: 'DialogMap'
  })
}

/**
 * Affiche une modal avec l'agent en paramètre
 * @param agent
 * @param readonly
 */
export const modalAgent = async (
  agent = {
    address: { country: store.getters['user/agencyCountry'] },
    agentInfos: {}
  }, readonly = false) => {
  throwUnlessGranted(
    agent,
    ACCOUNT_RIGHT_CREATE_AGENT,
    readonly
      ? ACCOUNT_RIGHT_READ_AGENT
      : ACCOUNT_RIGHT_EDIT_AGENT
  )
  if (!agent.id && store.getters['user/isAgentsLimitReached']) {
    await routerPush({ name: ROUTE_NAME_CHOOSE_PLAN })
    return toast.negative('Vous avez atteint votre quota de fiches agents')
  }
  const agency = store.getters['user/company']
  const modal = await _defaultModal({
    subject: {
      ...agent,
      agentInfos: {
        items: [],
        rating: 3,
        sendPlanning: agency.agentPlanningSettings.weeklyMailing,
        restrictions: [],
        ...agent.agentInfos,
        nextSubscription: getAgentSubscriptionValue(agent)
      }
    },
    props: {
      readonly
    },
    readonly,
    entityTitle: agent ? userName(agent) : null,
    type: 'agent',
    dialogName: 'DialogAgent',
    submit: (agent) => loadingHandler(async () => {
      await store.dispatch('user/agency/' + USER_AGENCY_POST_AGENT, agent)
      modal.hide()
    })
  })
}

/**
 * Modal de modification des chiens
 * @param dogs
 * @returns {Promise<void>}
 */
export const modalDogs = async (dogs = []) => {
  const modal = await _defaultModal({
    subject: dogs,
    type: 'chiens',
    dialogName: 'DialogDogs',
    submit: (dogs) => loadingHandler(async () => {
      const agent = store.state.user.utilisateur
      if (agent && agent.agentInfos) {
        await store.dispatch('user/' + USER_PUT_USER, {
          ...agent,
          agentInfos: {
            ...agent.agentInfos,
            dogs
          }
        })
      } else {
        toast.negative(`Impossible de modifier les chiens`)
      }
      modal.hide()
    })
  })
}

/**
 * Affiche une modal les infos de l'agent
 * @param agent
 */
export const modalShowAgent = async (agent) => {
  toast.info('Affichage de la fiche agent')
  devLog(agent)
  // const modal = await _defaultModal({
  //   subject: agent,
  //   type: 'agent',
  //   dialogName: 'DialogAgent',
  //   submit: (agent) => loadingHandler(async () => {
  //     await store.dispatch('user/agency/' + USER_AGENCY_POST_AGENT, agent)
  //     modal.hide()
  //   })
  // })
}

/**
 * Affiche une modal avec l'admin en paramètre
 * @param admin
 */
export const modalAdmin = async (admin = { rights: { ...ACCOUNT_MANAGER_DEFAULT_RIGHTS } }) => {
  if (!store.getters['user/isAgencyOwner']) {
    throw new Error('Accès interdit')
  }
  const modal = await _defaultModal({
    subject: admin,
    type: 'administrateur',
    dialogName: 'DialogAdmin',
    submit: (_manager) => loadingHandler(async () => {
      const { manager } = await postAgencyManager(_manager)
      $ui.$emit(MODAL_EVENT_UPDATE_MANAGER, [manager])
      modal.hide()
    })
  })
}

/**
 * Affiche une modal avec le client
 * @param customer
 * @param readonly
 */
export const modalCustomer = async (customer = {
  type: CUSTOMERS_TYPE_COMPANY,
  phone: [],
  users: [],
  companyContracts: [],
  customerInfos: { settlementPeriod: store.getters['user/company'].invoiceSettings.settlementPeriod },
  address: { country: store.getters['user/agencyCountry'] }
}, readonly = false) => {
  throwUnlessGranted(
    customer,
    ACCOUNT_RIGHT_CREATE_CUSTOMER,
    readonly
      ? ACCOUNT_RIGHT_READ_CUSTOMER
      : ACCOUNT_RIGHT_EDIT_CUSTOMER
  )
  const modal = await _defaultModal({
    subject: {
      customerInfos: {},
      documents: [],
      ...customer
    },
    type: 'client',
    props: {
      readonly
    },
    readonly,
    entityTitle: customer ? customer.name : null,
    dialogName: 'DialogCustomer',
    submit: (customer) => loadingHandler(async () => {
      await store.dispatch('user/agency/' + USER_AGENCY_POST_CLIENT, customer)
      modal.hide()
    })
  })
}

const getAgencyRightsCopy = (key) => {
  const {
    id,
    ...rights
  } = store.getters['user/company'][key] || {}
  return rights
}

/**
 * Affiche une modal avec le site
 * @param site
 * @param readonly
 */
export const modalSite = async (site = {
  address: {
    country: store.getters['user/agencyCountry'],
    location: {}
  },
  radius: 100,
  interventionReportEnabled: true,
  eventReportEnabled: true,
  siteUsers: []
}, readonly = false) => {
  throwUnlessGranted(
    site,
    ACCOUNT_RIGHT_CREATE_SITE,
    readonly
      ? ACCOUNT_RIGHT_READ_SITE
      : ACCOUNT_RIGHT_EDIT_SITE
  )

  const _site = {
    siteKeys: [],
    siteAlarms: [],
    rightsAgent: getAgencyRightsCopy('rightsAgent'),
    rightsCustomer: getAgencyRightsCopy('rightsCustomer'),
    ...site,
    items: [],
    checkpoints: site.id
      ? store.getters['user/agency/getSiteCheckpoints'](site)
      : []
  }
  let items = []
  if (site.id && store.getters['user/isGranted'](ACCOUNT_RIGHT_LIST_SITE_ITEMS)) {
    const { data } = await loadingHandler(() => getAgencySiteItems(site))
    items = _site.items = data
  }
  const modal = await _defaultModal({
    subject: _site,
    type: 'site',
    props: {
      readonly
    },
    readonly,
    entityTitle: site ? site.name : null,
    dialogName: 'DialogSite',
    submit: (site) => loadingHandler(async () => {
      const {
        id,
        slug
      } = await store.dispatch('user/agency/' + USER_AGENCY_POST_SITE, site)
      if (store.getters['user/isGranted'](ACCOUNT_RIGHT_EDIT_SITE_ITEMS) &&
        !_.isEqual(items, site.items)) {
        await postAgencySiteItems({
          id,
          slug,
          items: site.items
        })
      }
      modal.hide()
    })
  })
}

/**
 * Affiche une modal avec les clés et les alarmes en readonly
 * @param site
 */
export const modalKeyAlarm = async (site = {}) => {
  const _site = {
    siteKeys: [],
    siteAlarms: [],
    ...site
  }
  await _defaultModal({
    subject: _site,
    type: 'site',
    entityTitle: site ? site.name : null,
    title: 'Clés et alarmes du site',
    dialogName: 'DialogSiteKeyAccess'

  })
}

/**
 * Affiche une modal avec la ronde
 * @param ronde
 */
export const modalRonde = async (ronde = { checkpoints: [] }) => {
  throwUnlessGranted(ronde, ACCOUNT_RIGHT_CREATE_ROUND, ACCOUNT_RIGHT_EDIT_ROUND)
  const modal = await _defaultModal({
    subject: ronde,
    type: 'ronde',
    feminize: true,
    entityTitle: ronde && ronde.site ? `${ronde.name} - Site: ${ronde.site.name}` : null,
    dialogName: 'DialogRonde',
    submit: (ronde) => loadingHandler(async () => {
      await store.dispatch('user/agency/' + USER_AGENCY_POST_RONDE, ronde)
      modal.hide()
    })
  })
}

/**
 * Affiche une modal en lecture seule les informations d'un checkpoint
 * @param checkpoint
 * @returns {Promise<void>}
 */
export const modalCheckpointInfos = async (checkpoint) =>
  _defaultModal({
    subject: checkpoint,
    title: 'Informations sur le point de contrôle',
    type: 'point de contrôle',
    dialogName: 'DialogCheckpoint',
    entityTitle: checkpoint && checkpoint.site ? `${checkpoint.title} - Site: ${checkpoint.site.name}` : null,
    props: {
      readonly: true
    }
  })

/**
 * Affiche une modal avec le checkpoint
 * @param checkpoint
 */
export const modalCheckpoint = async (checkpoint = { location: {} }) => {
  throwUnlessGranted(checkpoint, ACCOUNT_RIGHT_CREATE_CHECKPOINT, ACCOUNT_RIGHT_EDIT_CHECKPOINT)
  const modal = await _defaultModal({
    subject: checkpoint,
    type: 'point de contrôle',
    dialogName: 'DialogCheckpoint',
    entityTitle: checkpoint && checkpoint.site ? [checkpoint.title, checkpoint.site.name].join(' - Site: ') : null,
    submit: (checkpoint) => loadingHandler(async () => {
      await store.dispatch('user/agency/' + USER_AGENCY_POST_CHECKPOINT, checkpoint)
      modal.hide()
    })
  })
}

/**
 * Affiche une modal en lecture seule avec l'exécution d'une ronde
 * @param serviceRoundExecution
 * @returns {Promise<void>}
 */
export const modalServiceRonde = async (serviceRoundExecution) =>
  _defaultModal({
    subject: serviceRoundExecution,
    title: 'Ronde du service',
    type: 'ronde',
    dialogName: 'DialogServiceRonde',
    props: {
      readonly: true
    }
  })

/**
 * Ouvre une modal avec une main courante
 * @param mainCourante
 * @param readonly
 * @returns {Promise<>}
 */
export const modalMainCourante = async (mainCourante = {}, readonly = false) => {
  if (readonly) {
    if (!(
      store.getters['user/isGranted'](ACCOUNT_RIGHT_LIST_MISSION_EVENTS) ||
      store.getters['user/isGranted'](ACCOUNT_RIGHT_READ_SITE_MISSION_EVENTS))) {
      throw new Error(getForbiddenMessage(ACCOUNT_RIGHT_LIST_MISSION_EVENTS))
    }
  } else {
    throwUnlessGranted(mainCourante, ACCOUNT_RIGHT_CREATE_MISSION_EVENT, ACCOUNT_RIGHT_EDIT_MISSION_EVENT)
  }
  await _defaultModal({
    subject: mainCourante,
    feminize: true,
    type: 'main courante',
    dialogName: 'DialogMainCourante',
    readonly
  })
}

/**
 * Affiche une modal avec un rapport d'intervention
 * @param {Object} report - La donnée du rapport
 * @param {Object} _form - Permet de préciser la version du template de formulaire
 * @param {Object} props - Les props additionnelle
 */
export const modalInterventionReport = (report = {}, _form, props = {}) => {
  const form = _form || store.getters['user/company'].interventionReportTemplate
  const _report = {
    ...report
  }
  if (Array.isArray(_report.json)) { // PHP Array => Object convertion
    _report.json = {}
  }
  return _defaultModal({
    subject: _report,
    props: {
      form,
      ...props
    },
    type: `bon d'intervention`,
    dialogName: 'DialogInterventionReport'
  })
}

/**
 * Affiche une modal avec un rapport d'intervention et met en place la sauvegarde en mode admin
 * @param {Object} _report - La donnée du rapport
 * @param {Object} _form - Permet de préciser la version du template de formulaire
 */
export const modalAdminInterventionReport = async (_report = {}, _form) => {
  throwUnlessGranted(_report, ACCOUNT_RIGHT_CREATE_INTERVENTION_REPORT, ACCOUNT_RIGHT_EDIT_INTERVENTION_REPORT)
  const modal = await modalInterventionReport(
    _report,
    _form,
    {
      noService: !_report.service,
      customerSignature: _report.status < INTERVENTION_REPORTS_STATUS_SIGNED_CUSTOMER
    })
  modal.on('submit', (report) =>
    loadingHandler(async () => {
      const { interventionReport } = await postAgencyInterventionReport(report)
      modal.hide()
      $ui.$emit(MODAL_EVENT_UPDATE_INTERVENTION_REPORTS, [interventionReport])
    })
  )
}

/**
 * Ouvre une modal avec un document commercial
 * @param id
 * @param settings
 * @param modalOpt
 * @returns {function(*=): *}
 * @private
 */
const _modalCommercialDoc = ({
  id,
  ...settings
}, modalOpt = {}) =>
  async (doc = {}) => {
    const _doc = Array.isArray(doc)
      ? doc
      : _.merge(
        {
          version: 'mail',
          date: dateFormatIso(new Date()),
          items: []
        },
        settings,
        doc
      )
    return _defaultModal({
      subject: _doc,
      type: 'devis',
      entityTitle: _doc && _doc.customer ? `${_doc.customer.name} - ${_doc.number}` : null,
      dialogName: 'DialogCommercialDoc' + (Array.isArray(_doc) ? 's' : ''),
      ...modalOpt
    })
  }

/**
 * Affiche une modal avec le devis
 * @param estimate
 */
export const modalEstimate = async (
  estimate = {
    [COMMERCIAL_DOC_TYPE_ESTIMATE_CUSTOMER_KEY]: { country: store.getters['user/agencyCountry'] }
  }) => {
  throwUnlessGranted(estimate, ACCOUNT_RIGHT_CREATE_ESTIMATE, ACCOUNT_RIGHT_EDIT_ESTIMATE)
  const estimateSettings = store.getters['user/company'].estimateSettings || {}
  const modal = await _modalCommercialDoc(estimateSettings, {
    type: COMMERCIAL_DOC_TYPE_ESTIMATE,
    submit: (_estimate) => loadingHandler(async () => {
      const { estimate } = await postAgencyEstimate(_estimate)
      if (estimate.status === COMMERCIAL_DOCS_STATUS_DELETED ||
        !store.getters['user/isGranted'](ACCOUNT_RIGHT_EDIT_ESTIMATE)) {
        modal.hide()
      } else {
        modal.setValue(estimate)
      }
      $ui.$emit(MODAL_EVENT_UPDATE_ESTIMATES, [estimate])
    })
  })(estimate)
}

/**
 * Affiche une modal créer/modifier les abonnements
 * @param invoiceRecurrence
 */
export const modalInvoiceRecurrence = async (invoiceRecurrence = {}) => {
  const modal = await _defaultModal({
    subject: invoiceRecurrence,
    type: 'abonnement',
    dialogName: 'DialogInvoiceRecurrence',
    props: {
      invoiceRecurrence: invoiceRecurrence
    },
    submit: (_invoiceRecurrence) => loadingHandler(async () => {
      const invoiceRecurrence = await postAgencyInvoicesRecurrence(_invoiceRecurrence)
      $ui.$emit(MODAL_EVENT_UPDATE_INVOICE_RECURRENCE, [invoiceRecurrence])
      modal.hide()
    })
  })
}

/**
 * Permet d'envoyer un devis
 * @param estimate
 * @returns {Promise<void>}
 */
export const modalEstimateSend = async (estimate = {}) => {
  throwUnlessGranted(estimate, ACCOUNT_RIGHT_SEND_ESTIMATE, ACCOUNT_RIGHT_SEND_ESTIMATE)
  const estimateSettings = store.getters['user/company'].estimateSettings || {}
  const file = typeof estimate.file === 'string'
    ? { name: _.last(estimate.file.split('/')) }
    : estimate.file
  const to = []
  // TODO a uniformiser
  const _customerEmail = _.get(estimate, [COMMERCIAL_DOC_TYPE_ESTIMATE_CUSTOMER_EMAIL_KEY]) ||
    _.get(estimate, [COMMERCIAL_DOC_TYPE_CUSTOMER_EMAIL_KEY, 'email']) ||
    _.get(estimate, [COMMERCIAL_DOC_TYPE_ESTIMATE_CUSTOMER_KEY, 'email'])
  if (_customerEmail) {
    to.push(_customerEmail)
  }
  const _customerSlug = _.get(estimate, [COMMERCIAL_DOC_TYPE_CUSTOMER_SLUG_KEY])
  const customerEmails = store.getters['user/agency/customerEmails'](_customerSlug)
  to.concat(customerEmails)
  const email = _.merge(
    {
      message: ''
    },
    estimateSettings.email,
    {
      to,
      lockedAttachments: [file]
    }
  )
  const modal = await modalEmail(email, { auto: true })
  modal.on(
    'submit', () => loadingHandler(async () => {
      const { id } = estimate
      await postAgencyEstimate({
        id,
        sent: true
      })
      $ui.$emit(MODAL_EVENT_UPDATE_ESTIMATES)
    })
  )
}

/**
 * Affiche une modal avec la facture
 * @param invoice
 */
export const modalInvoice = async (
  invoice = {
    [COMMERCIAL_DOC_TYPE_INVOICE_CUSTOMER_KEY]: { country: store.getters['user/agencyCountry'] },
    type: COMMERCIAL_DOC_TYPE_INVOICE_INVOICE
  }) => {
  throwUnlessGranted(invoice, ACCOUNT_RIGHT_CREATE_INVOICE, ACCOUNT_RIGHT_EDIT_INVOICE)
  const invoiceSettings = store.getters['user/company'].invoiceSettings || {}
  const modal = await _modalCommercialDoc(invoiceSettings, {
    type: COMMERCIAL_DOC_TYPE_INVOICE,
    feminize: true,
    submit: async (_invoice) => {
      if (
        _invoice.customer &&
        _invoice.customer.customerInfos &&
        _invoice.customer.customerInfos.prospect
      ) {
        await tryCatchConfirm(async () => {
          await promiseConfirm({
            title: `Basculement du prospect en client`,
            message: `Valider le passage du prospect en client ?\r\nCela retirera l'option "Prospect" de la fiche client`,
            cancel: 'Non'
          })
          await loadingHandler(
            async () => store.dispatch(
              'user/agency/' + USER_AGENCY_POST_CLIENT,
              {
                id: _invoice.customer.id,
                customerInfos: {
                  prospect: false
                }
              }),
            {
              message: 'Basculement du prospect en client',
              reject: true
            }
          )
        })
      }
      return loadingHandler(async () => {
        const { invoice } = await postAgencyInvoice(_invoice)
        if (invoice.status === COMMERCIAL_DOCS_STATUS_DELETED ||
          !store.getters['user/isGranted'](ACCOUNT_RIGHT_EDIT_INVOICE)) {
          modal.hide()
        } else {
          modal.setValue(invoice)
        }
        $ui.$emit(MODAL_EVENT_UPDATE_INVOICES, [invoice])
      })
    }
  })(invoice)
}

/**
 * Permet d'envoyer une facture
 * @param invoice
 * @returns {Promise<void>}
 */
export const modalInvoiceSend = async (invoice = {}) => {
  throwUnlessGranted(invoice, ACCOUNT_RIGHT_SEND_INVOICE, ACCOUNT_RIGHT_SEND_INVOICE)
  const { invoiceSettings = {} } = store.getters['user/company']
  const getCustomer = store.getters['user/agency/getCustomer']
  const to = []
  const _customer = getCustomer(_.get(invoice, ['customer', 'slug']))
  const _customerEmail = _.get(invoice, [COMMERCIAL_DOC_TYPE_INVOICE_CUSTOMER_KEY, 'email'], _customer ? _customer.email : null)
  if (_customerEmail) {
    to.push(_customerEmail)
  }
  const customerEmails = store.getters['user/agency/customerEmails'](_.get(invoice, ['customer', 'slug']))
  to.concat(customerEmails)
  const email = _.merge(
    {
      message: ''
    },
    invoiceSettings.email,
    {
      to,
      lockedAttachments: [{
        ...invoice.file,
        name: _.last(invoice.file.url.split('/')),
        locked: true
      }]
    }
  )
  const modal = await modalEmail(email, { auto: true })
  modal.on(
    'submit',
    () => loadingHandler(async () => {
      const { id } = invoice
      await postAgencyInvoice({
        id,
        sent: true
      })
      $ui.$emit(MODAL_EVENT_UPDATE_INVOICES)
    })
  )
}

/**
 * Affiche une modal avec les paiements d'une facture
 * @param invoice
 */
export const modalInvoicePayments = async (invoice = {}) => {
  throwUnlessGranted(invoice, ACCOUNT_RIGHT_CREATE_INVOICE, ACCOUNT_RIGHT_EDIT_INVOICE)
  const modal = await _defaultModal({
    subject: invoice,
    type: 'règlement',
    dialogName: 'DialogCommercialDocPayments',
    submit: ({
      id,
      partialPayments = []
    }) => loadingHandler(async () => {
      const { invoice } = await postAgencyInvoice({
        id,
        partialPayments
      })
      modal.setValue(invoice)
      $ui.$emit(MODAL_EVENT_UPDATE_INVOICES, [invoice])
    })
  })
}

/**
 * Affiche une modal pour gérer les tarifs d'une spécialité
 * @param pricing
 * @param basePricing
 */
export const modalSpecialtyPricing = (pricing = {}, basePricing = {}) => {
  return _defaultModal({
    subject: pricing,
    type: 'tarification',
    dialogName: 'DialogSpecialtyPricing',
    props: {
      basePricing: basePricing
    }
  })
}

/**
 * Ouvre une modal avec un cahier des charges
 * @returns {Promise<>}
 * @param site
 */
export const modalSiteInstructions = async (site = {}) => {
  await _defaultModal({
    subject: site,
    title: `Instructions du site - ${site.name}`,
    dialogName: 'DialogSiteInstructions'
  })
}

/**
 * Modal création/modification d'un changelog
 * @param changelog
 * @returns {Promise<void>}
 */
export const modalChangelog = (changelog) => {
  return loadingHandler(async () => {
    const modal = await _defaultModal({
      subject: changelog,
      type: 'changelog',
      dialogName: 'DialogChangelog',
      submit: (_changelog) => loadingHandler(async () => {
        const changelog = await postChangelog(_changelog)
        $ui.$emit(MODAL_EVENT_UPDATE_CHANGELOG, [changelog], true)
        modal.hide()
      })
    })
  })
}

/**
 * Ouvre une modal avec un template de contrat
 * @returns {Promise<>}
 * @param contractTemplate
 * @param type
 */
export const modalContractTemplate = async (type, contractTemplate = {}) => {
  contractTemplate = {
    ...contractTemplate,
    body: contractTemplate.body
      ? textToHtml(contractTemplate.body, type)
      : ''
  }

  const modal = await _defaultModal({
    subject: contractTemplate,
    title: `Contrat ${type === CONTRACT_TYPES_CUSTOMER
      ? 'client'
      : 'agent'} - ${contractTemplate.title ?? 'Nouveau contrat'}`,
    dialogName: 'DialogContractTemplate',
    type
  })

  modal.on(
    'submit',
    ({ ...cTemplate }) => loadingHandler(async () => {
      cTemplate.body = chipedTextToText(cTemplate.body)

      let _contratResponse
      let eventType

      if (type === CONTRACT_TYPES_CUSTOMER) {
        _contratResponse = await postAgencyCustomerContractTemplate(cTemplate)
        eventType = MODAL_EVENT_UPDATE_CUSTOMER_CONTRACT_TEMPLATE
      } else {
        _contratResponse = await postAgencyAgentContractTemplate(cTemplate)
        eventType = MODAL_EVENT_UPDATE_AGENT_CONTRACT_TEMPLATE
      }

      $ui.$emit(eventType, [_contratResponse.contract])
      modal.hide()
    })
  )
}

/**
 * Ouvre une modal avec un contrat
 * @returns {Promise<>}
 * @param contract
 * @param type
 */
export const modalContract = async (type, contract = {}) => {
  const oContract = {
    ...contract
  }
  if (!oContract.emails) {
    oContract.emails = [store.getters['user/company'].email]
    if (type === CONTRACT_TYPES_CUSTOMER && oContract.customer && oContract.customer.email) {
      oContract.emails.push(oContract.customer.email)
    }
    if (type === CONTRACT_TYPES_AGENT && oContract.agent && oContract.agent.email) {
      oContract.emails.push(oContract.agent.email)
    }
  }
  return _defaultModal({
    subject: oContract,
    title: `Contrat ${type === CONTRACT_TYPES_CUSTOMER ? 'Client' : 'Agent'} - ${contract.title ?? 'Nouveau contrat'}`,
    dialogName: 'DialogContract',
    props: {
      type
    }
  })
}

/**
 * Permet d'envoyer un contract
 * @returns {Promise<void>}
 * @param {Object} contract
 * @param {Object} signature
 * @param type
 */
export const modalContractSend = async (type, contract = {}, signature = {}) => {
  // Si c'est un client ou un agent, et que celui ci à un email ou non
  const to = type === CONTRACT_TYPES_CUSTOMER
    ? contract.customer.email
      ? [contract.customer.email]
      : []
    : contract.agent.email
      ? [contract.agent.email]
      : []

  const signLink = signature
    ? `${process.env.APP.app.front}/?#/signature/${type}/${contract.id}/${signature.signatureToken}`
    : ''
  const signMessage = signLink
    ? `Vous pouvez signer le document ici : <a href="${signLink}"><u>${signLink}</u></a>.`
    : ''
  const _email = _.merge(
    {
      subject: 'Votre contrat - ' + store.getters['user/company'].name,
      message: `Bonjour,<br><br>
        Un nouveau contrat à été rédigé à votre attention. ${signMessage}<br><br>
        Cordialement.`
    },
    {
      to,
      lockedAttachments: [{
        ...contract.file,
        name: _.last(contract.file.url.split('/')),
        locked: true
      }]
    }
  )

  await modalEmail(
    _email,
    { auto: true }
  )
}

/**
 * Affiche une modal pour dupliquer le planning
 */
export const modalDuplicatePlanning = async (_value = {}) => {
  const modal = await _defaultModal({
    type: 'planning',
    dialogName: 'DialogDuplicatePlanning',
    props: {
      value: _value
    },
    submit: (options) => loadingHandler(async () => {
      const {
        errors,
        servicesFromCount,
        servicesToCount
      } = await duplicatePlanning(options)
      if (servicesFromCount === servicesToCount) {
        toast.positive({
          message: `Duplication terminée`,
          caption: `${servicesToCount} service(s) copié(s)`
        })
      } else {
        const mappedErrors = SERVICES_DUPLICATE_PLANNING_ERRORS
          .filter(({ value }) => errors[value])
          .map(({
            label,
            value
          }) => `<div>- ${errors[value]} ${label.toLowerCase()}</div>`)
          .join('')
        toast.warning({
          message: `Duplication terminée avec erreurs`,
          caption: `<div>- ${servicesToCount} sur ${servicesFromCount} services copiés.</div>${mappedErrors}`,
          multiLine: true,
          html: true
        })
      }
      modal.hide()
    })
  })
}

/**
 * Modal création/modification d'un feedback
 * @returns {Promise<void>}
 * @param feedback
 * @param readonly
 */
export const modalFeedback = (feedback = {}, readonly = false) => {
  return loadingHandler(async () => {
    const modal = await _defaultModal({
      subject: feedback,
      type: 'feedback',
      dialogName: 'DialogFeedback',
      readonly,
      submit: (_feedback) => loadingHandler(async () => {
        const feedback = await postFeedback(_feedback)
        $ui.$emit(MODAL_EVENT_UPDATE_FEEDBACK, [feedback], true)
        if (!_feedback.id) {
          toast.info('Merci pour votre contribution à rendre SEKUR encore meilleur !')
        }
        modal.hide()
      })
    })
  })
}
